import { IconProps } from "../../types/utils";

const ArrowIcon = ({ color, dimension, ...props }: IconProps) => (
  <svg
    width={dimension || 24}
    height={dimension || 24}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.5335 18.0182L5.25001 12.7346C5.05237 12.5362 4.94141 12.2675 4.94141 11.9875C4.94141 11.7074 5.05237 11.4387 5.25001 11.2403L10.5335 5.95676C10.7356 5.77899 10.9978 5.68482 11.2667 5.69341C11.5357 5.702 11.7914 5.81269 11.9817 6.00299C12.172 6.19329 12.2826 6.44892 12.2912 6.71791C12.2998 6.9869 12.2057 7.24906 12.0279 7.45111L8.54789 10.9311H18.678C18.8224 10.922 18.9671 10.9425 19.1033 10.9915C19.2394 11.0404 19.3641 11.1168 19.4696 11.2158C19.5751 11.3148 19.6592 11.4344 19.7166 11.5672C19.7741 11.7 19.8038 11.8431 19.8038 11.9878C19.8038 12.1325 19.7741 12.2757 19.7166 12.4084C19.6592 12.5412 19.5751 12.6608 19.4696 12.7598C19.3641 12.8588 19.2394 12.9352 19.1033 12.9842C18.9671 13.0331 18.8224 13.0537 18.678 13.0445H8.54789L12.0279 16.5245C12.1366 16.6201 12.2245 16.737 12.2862 16.8679C12.3479 16.9988 12.3821 17.141 12.3868 17.2857C12.3914 17.4303 12.3663 17.5744 12.313 17.709C12.2598 17.8436 12.1795 17.9658 12.0772 18.0682C11.9748 18.1705 11.8526 18.2508 11.718 18.304C11.5834 18.3573 11.4393 18.3824 11.2947 18.3777C11.15 18.3731 11.0078 18.3389 10.8769 18.2772C10.746 18.2154 10.6291 18.1275 10.5335 18.0189V18.0182Z"
      fill={color || "#9CA7B7"}
    />
  </svg>
);

export default ArrowIcon;
